class ToggleSwitch extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: inline-block;
                    width: 60px; /* Reduced width */
                    height: 30px; /* Reduced height */
                }
                .toggle-switch {
                    display: block;
                    position: relative;
                    width: 100%;
                    height: 100%;
                    cursor: pointer;
                }
                .toggle-switch input[type="checkbox"] {
                    display: none;
                }
                .toggle-switch-background {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: #ddd;
                    border-radius: 15px; /* Adjusted for smaller size */
                    box-shadow: inset 0 0 0 2px #ccc;
                    transition: background-color 0.3s ease-in-out;
                }
                .toggle-switch-handle {
                    position: absolute;
                    top: 2.5px; /* Adjusted for smaller size */
                    left: 2.5px; /* Adjusted for smaller size */
                    width: 25px; /* Adjusted for smaller size */
                    height: 25px; /* Adjusted for smaller size */
                    background-color: #fff;
                    border-radius: 50%;
                    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
                    transition: transform 0.3s ease-in-out;
                }
                .toggle-switch input[type="checkbox"]:checked + .toggle-switch-background {
                    background-color: var(--accent-color, #05c46b);
                }
                .toggle-switch input[type="checkbox"]:checked + .toggle-switch-background .toggle-switch-handle {
                    transform: translateX(30px); /* Adjusted for smaller size */
                }
                :host([disabled]) .toggle-switch {
                    cursor: not-allowed;
                    opacity: 0.5;
                }
            </style>
            <label class="toggle-switch">
                <input type="checkbox">
                <div class="toggle-switch-background">
                    <div class="toggle-switch-handle"></div>
                </div>
            </label>
        `;

        this.checkbox = this.shadowRoot.querySelector('input[type="checkbox"]');
        this.checkbox.addEventListener('change', () => this.toggleCartAttribute());
    }

    async connectedCallback() {
        this.updateDisabledState(true); // Disable on load until the cart is fetched
        if (this.hasAttribute('accent-color')) {
            this.style.setProperty('--accent-color', this.getAttribute('accent-color'));
            this.shadowRoot.querySelector('label').style.setProperty('--accent-color', this.getAttribute('accent-color'));
        }
        try {
            const cart = await this.fetchCart();
            const storeCreditApplied = cart.attributes && cart.attributes.memberr_apply_store_credit === 'Yes';
            this.checkbox.checked = storeCreditApplied;
            this.updateDisabledState(false); // Enable after fetching cart
        } catch (error) {
            console.error('Failed to fetch or parse cart data:', error);
            this.updateDisabledState(false); // Ensure it is enabled even if there is an error
        }
    }

    static get observedAttributes() {
        return ['accent-color'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'accent-color') {
            this.style.setProperty('--accent-color', newValue);
        }
    }

    async toggleCartAttribute() {
        this.updateDisabledState(true); // Disable while updating
        try {
            const cart = await this.fetchCart();
            const apply = !(cart.attributes && cart.attributes.memberr_apply_store_credit === 'Yes');
            await this.updateCartAttribute(apply);
            this.checkbox.checked = apply;
        } catch (error) {
            console.error('Error in toggle operation:', error);
        }
        this.updateDisabledState(false); // Re-enable after update
    }

    updateDisabledState(isDisabled) {
        if (isDisabled) {
            this.setAttribute('disabled', '');
        } else {
            this.removeAttribute('disabled');
        }
    }

    async fetchCart() {
        try {
            const response = await fetch('/cart.js');
            return response.json();
        } catch (error) {
            console.error('Error fetching cart:', error);
            return {};
        }
    }

    async updateCartAttribute(apply) {
        const attributes = {
            memberr_apply_store_credit: apply ? 'Yes' : 'No'
        };

        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes })
            });
            const data = await response.json();
            console.log('Cart updated:', data);
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    }
}

customElements.define('memberr-toggle', ToggleSwitch);
